import React, {useEffect, useState, useRef} from 'react';
import {useReactToPrint} from 'react-to-print';
import {useSearchParams, useNavigate} from 'react-router-dom';

import { useSelector } from 'react-redux';

import _ from 'lodash';
import classnames from 'classnames/bind';
import {
  IRecommendations,
  IState,
  IVehicle,
  ProductCategory,
  Replacement,
} from '../../../interface';
import style from './index.module.scss';
import VehicleDropdown from '../VehicleDropdown';
import CastrolRecommendation from './CastrolRecommendation';
import AlternativeRecommendation from './AlternativeRecommendation';
import Printable from '../../RecommendationPrintable/Components';
import Loading from '../../Loading';
import {connect} from 'react-redux';
import localesReplacement from '../../../utils/localesReplacement';
import {Dispatch} from 'redux';
import actions from '../../../redux/actions';

import {
  getRecommendations,
  //getProduct
} from '../../../services';
import {useAppName} from '../../../hooks/use-app-names';
import {ANALYTICS_BUTTON_NAME, ANALYTICS_EVENT, ANALYTICS_PAGE_TYPE, APPNAME, ENABLEDWORKSHOPSOWNER, FASTSCAN} from '../../../constants';
import { Variant } from '../../../constants/variants';
import {FailedRecommendation} from '../../FailedRecommendation';
import FindTheRightOil from '../FindTheRightOil';
import {UnderMaintenance} from '../../UnderMaintenance';
// import Parser from 'html-react-parser';
import {useMediaQuery} from 'react-responsive';
import OwnerSelector from '../OwnerSelector';
import { useAnalytics } from '../../../hooks/use-analytics';

const cx = classnames.bind(style);
const primaryButton = 'primary-button';

interface Props {
  vehicle: IVehicle | undefined;
  replacements: Replacement;
  setVehicle: (value: IVehicle) => void;
  productCategoriesList: ProductCategory[] | null;
  setRecommendedProducts: (v: IRecommendations[]) => void;
  recommendedProducts: IRecommendations[];
  trade: boolean;
  setTrade: (v: boolean) => void;
}

// eslint-disable-next-line sonarjs/cognitive-complexity
export const Product = (props: Props) => {
  const {
    vehicle,
    replacements,
    setVehicle,
    productCategoriesList,
    setRecommendedProducts,
    recommendedProducts,
    trade,
    setTrade,
  } = props;
  const isFastScan = useAppName(FASTSCAN);
  const i18n = localStorage.getItem('languageCode') as string;

  const country = useSelector((state: any) => state.country);

  const [searchParams, setSearchParams] = useSearchParams();
  const vehicleId = searchParams.get('id');
  const [dropdownClassName, setDropdownClassName] = useState<string>('');
  const [component, setComponent] = useState<number>(0);
  const [isMount, setIsMount] = useState<boolean>(false);
  //const [allRightsRsrdName, setAllRightsRsrdName] = useState<string>(' ');
  //const [allRightsRsrdMsg, setAllRightsRsrdMsg] = useState<string>(' ');
  //const productId = 77777 as number;
  const ref = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const [underMaintnance, setUnderMaintenance] = useState<boolean>(false);
  const sendAnalytics = useAnalytics();

  const variant = searchParams.get('variant');
  const isFord = variant === Variant.FORD;

  useEffect(() => {
    setIsMount(true);
    setUnderMaintenance(false);
    setComponent(0);
    const controller = new AbortController();
    let isMounted = true;
    vehicleId &&
      getRecommendations(vehicleId, trade)
        .then((d) => {
          if (d.status !== 200) {
            setUnderMaintenance(true);
            setIsMount(false);
            return;
          }
          isMounted && setVehicle(d.data.vehicle);
          isMounted && setRecommendedProducts(d.data.components);
          isMounted && setIsMount(false);
          //getAllRightsReservedInfo();
        })
        .catch(() => {
          setRecommendedProducts([]);
          setIsMount(false);
        });
    const stored = sessionStorage.getItem('vehicleType');
    if (stored) {
      const type = localesReplacement(replacements, stored);
      setDropdownClassName(type);
    }
    return () => {
      controller.abort();
      isMounted = false;
    };
  }, [vehicleId, trade, country]);
  useEffect(() => {
    if (recommendedProducts.length > 0) {
      sendAnalytics({
        event: ANALYTICS_EVENT.RECOMMENDED_OIL_VIEW ,
        page: ANALYTICS_PAGE_TYPE.RECOMMENDED_OILS,
        oilName: recommendedProducts[0]?.recommendedProduct?.name,
        oilCategory: `${recommendedProducts[0]?.name} ${recommendedProducts[0]?.code}`,
        model: `${vehicle?.make} ${vehicle?.model}`,
        country: country,
      });
    }
  }, [recommendedProducts]);

  const alternateProducts = recommendedProducts
    ? recommendedProducts[component]?.alternateProducts
    : [];

  const castrolRecommendation = _.get(recommendedProducts, component);

  const handleShare = () => {
    const data = {
      title: `${vehicle?.make} - ${vehicle?.model} - ${vehicle?.type}`,
      text:
        localesReplacement(
          replacements,
          "Thank you for visiting Castrol Motor Oil and Fluid finder! Here's a link to the page you've shared",
        ) +
        '\n' +
        "Thank you for visiting Castrol Motor Oil and Fluid finder! Here's a link to the page you've shared",
      url: window.location.href,
    };
    if ('share' in navigator) {
      void (async function main() {
        try {
          await navigator.share(data);
        } catch (e) {
          const error = 1;
          throw new Error(error.toString());
        }
      })();
    } else {
      const body = encodeURIComponent(`${data.text} ${data.url}`);
      const url = `mailto:?subject=${encodeURIComponent(
        data.title,
      )}&body=${body}`;
      window.location.href = url;
    }
  };

  const printOptions = {
    content: () => ref?.current,
    copyStyles: true,
  };
  const handlePrint = useReactToPrint(printOptions);

  const handleBack = () => {
    navigate(-1);
  };

  const componentDataLayer = (data: string) => {
    sendAnalytics({
      event: ANALYTICS_EVENT.RECOMMENDED_OIL_VIEW ,
      page: ANALYTICS_PAGE_TYPE.RECOMMENDED_OILS,
      oilName: recommendedProducts[0]?.recommendedProduct?.name,
      oilCategory: data,
      model: `${vehicle?.make} ${vehicle?.model}`,
      country: country,
    });
  };

  // const getAllRightsReservedInfo = () => {
  //   getProduct(productId).then((d) => {
  //     let name = d.data.description;
  //     if (name) {
  //       name = name.split('</p>');
  //       setAllRightsRsrdName(name[0].toUpperCase());
  //       setAllRightsRsrdMsg(name[1]);
  //     }
  //   });
  // };

  const [tabsVisible, setTabsVisible] = useState(false);
  const [searchVisible, setSearchVisible] = useState(false);
  const isDesktopOrLaptop = useMediaQuery({minWidth: 1024});

  const onWTBClick = () => {
    sendAnalytics({
      event: ANALYTICS_EVENT.WHERE_TO_BUY_CLICK ,
      page: ANALYTICS_PAGE_TYPE.PRODUCT_FINDER,
      button: ANALYTICS_BUTTON_NAME.WHERE_TO_BUY,
      country: country,
    });
    searchParams.set('page', 'wheretobuy');
    isFastScan && searchParams.set(APPNAME, FASTSCAN);
    setSearchParams(searchParams);
  };
  const onVehicleSelect = (value: string | number, model?: string) => {
    //value=18f847ba17864033e0659fbab47aa869
    sendAnalytics({
      event: ANALYTICS_EVENT.VIEW_RECOMMENDED_OILS_CLICK ,
      page: ANALYTICS_PAGE_TYPE.PRODUCT_FINDER,
      button: ANALYTICS_BUTTON_NAME.VIEW_RECOMMENDED_OILS,
      model: model,
      country: country,
    });
    searchParams.set('page', 'recommendedProducts');
    searchParams.set('id', _.toString(value));
    isFastScan && searchParams.set(APPNAME, FASTSCAN);
    setSearchParams(searchParams);
    setSearchVisible(false);
  };
  const onProductSelect = (value: string | number, product?: string) => {
    sendAnalytics({
      event: ANALYTICS_EVENT.VIEW_PRODUCT_PAGE_CLICK ,
      page: ANALYTICS_PAGE_TYPE.PRODUCT_FINDER,
      button: ANALYTICS_BUTTON_NAME.VIEW_PRODUCT_PAGE,
      oilName: product,
      country: country,
    });

    searchParams.set('page', 'product');
    searchParams.set('id', _.toString(value));
    isFastScan && searchParams.set(APPNAME, FASTSCAN);
    setSearchParams(searchParams);
    setSearchVisible(false);
  };

  return (
    <>
      {castrolRecommendation && (
        <Printable vehicle={vehicle} ref={ref} data={recommendedProducts} />
      )}
      <>
        {isMount ? (
          <Loading />
        ) : (
          <div className={cx('content')}>
            <div className='owner-selector'>
              {country && _.includes(ENABLEDWORKSHOPSOWNER, country) && !isFord ? (
                <OwnerSelector
                  replacements={replacements}
                  selectedIndex={trade}
                  setSelectedIndex={(b) => {
                    sendAnalytics({
                      event: b ? ANALYTICS_EVENT.WORKSHOP_OWNER_CLICKS : ANALYTICS_EVENT.VEHICLE_OWNER_CLICKS,
                      country: country,
                    });
                    setTrade(b);
                    sessionStorage.setItem('selectedType', _.toString(b));
                  }}
                />
              ) : null}
            </div>
            {/* filter section */}
            {vehicle && (
              <div className={cx('filter-secion')}>
                <div
                  className={cx('vehicle')}
                  onClick={() => setSearchVisible(true)}
                >
                  <VehicleDropdown
                    dataList={vehicle}
                    className={dropdownClassName}
                    replacements={replacements}
                  />
                </div>
                {!isMount && (
                  <div className={cx('component')}>
                    <span
                      className={cx('dropdown', {open: tabsVisible})}
                      onClick={() => setTabsVisible(true)}
                    >
                      Compartment Filter:{' '}
                      <em>{recommendedProducts[component]?.name}</em>
                    </span>
                  </div>
                )}
              </div>
            )}
            {!underMaintnance ? (
              <>
                {!_.isEmpty(recommendedProducts) ? (
                  <>
                    {/** tabs section */}
                    {recommendedProducts && (
                      <>
                        <div
                          className={cx('tabs-mask', {on: tabsVisible})}
                          onClick={() => setTabsVisible(false)}
                        ></div>
                        <div className={cx('tabs', {on: tabsVisible})}>
                          <div className={cx('tabs-caption')}>PRODUCT TYPE</div>
                          <ul>
                            {_.map(recommendedProducts, (tab, index) => (
                              <li key={index}>
                                <span
                                  className={`link ${cx({
                                    actived: _.isEqual(component, index),
                                  })} ${cx({
                                    empty:
                                      'recommendedProduct' in tab === false,
                                  })}`}
                                  role='link'
                                  onClick={() => {
                                    setComponent(index);

                                    const code = tab['code']
                                      ? `(${tab['code']})`
                                      : '';
                                    componentDataLayer(
                                      `${tab['name']} ${code}}`,
                                    );
                                    setTabsVisible(false);
                                  }}
                                >
                                  {tab['name']}{' '}
                                  {tab['code'] ? `(${tab['code']})` : ''}
                                </span>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </>
                    )}
                    <div className={cx('buttons')}>
                      <button
                        onClick={handlePrint}
                        className={`${cx(primaryButton)} ${cx('print')}`}
                      >
                        {localesReplacement(replacements, 'Print')}
                      </button>
                      <button
                        onClick={handleShare}
                        className={`${cx(primaryButton)} ${cx('share')}`}
                      >
                        {localesReplacement(replacements, 'Share')}
                      </button>

                      <div className={cx('back-btn-plece')}>
                        <button
                          onClick={handleBack}
                          className={`${cx(primaryButton)} ${cx('home')}`}
                        >
                          {localesReplacement(replacements, 'Home')}
                        </button>
                        <button
                          onClick={handleBack}
                          className={`${cx(primaryButton)} ${cx('back')}`}
                        >
                          {localesReplacement(replacements, 'Back')}
                        </button>
                      </div>
                    </div>

                    {/** Castrol Recommendation */}
                    {!_.isEmpty(recommendedProducts) && (
                      <>
                        {castrolRecommendation &&
                          'recommendedProduct' in castrolRecommendation && (
                            <div className={cx('recommendation')}>
                              <CastrolRecommendation
                                dataList={castrolRecommendation}
                                vehicle={vehicle}
                                notes={castrolRecommendation?.notes}
                                productCategories={
                                  productCategoriesList
                                    ? productCategoriesList
                                    : []
                                }
                              />
                            </div>
                          )}
                        {'recommendedProduct' in castrolRecommendation ===
                          false && (
                          <div className={cx('failed-recommendation')}>
                            <FailedRecommendation
                              notes={castrolRecommendation?.notes}
                              replacements={replacements}
                            />
                          </div>
                        )}
                        {/** Alternative Recommendation */}
                        {!_.isEmpty(alternateProducts) && (
                          <div className={cx('alertnative-section')}>
                            <h3>
                              {localesReplacement(
                                replacements,
                                'Alternative Recommendation',
                              )}
                            </h3>
                            <div className={cx('rows')}>
                              {_.map(alternateProducts, (dataList, index) => (
                                <div className={cx('column')} key={index}>
                                  <div className={cx('block')}>
                                    <AlternativeRecommendation
                                      dataList={dataList}
                                      vehicle={vehicle}
                                      notes={castrolRecommendation.notes}
                                      productCategories={
                                        productCategoriesList
                                          ? productCategoriesList
                                          : []
                                      }
                                      componentName={castrolRecommendation.name}
                                      vehicleComponentVolumes={
                                        castrolRecommendation.vehicleComponentVolumes
                                      }
                                      onlyThumb={true}
                                    />
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                        {/* <div>
                    <div className={cx('alr-color')}>
                      <h4>
                        {allRightsRsrdName !== ' '
                          ? Parser(allRightsRsrdName)
                          : ''}
                      </h4>
                    </div>
                    <div className={cx('alr-desc')}>
                      {allRightsRsrdMsg !== ' ' ? Parser(allRightsRsrdMsg) : ''}
                    </div>
                  </div> */}
                      </>
                    )}
                  </>
                ) : (
                  <div className={cx('no-content')}>
                    <FailedRecommendation
                      notes={castrolRecommendation?.notes}
                      replacements={replacements}
                    />
                  </div>
                )}
              </>
            ) : (
              <UnderMaintenance replacements={replacements} />
            )}
          </div>
        )}
      </>
      {searchVisible && !isDesktopOrLaptop && (
        <div className={cx('findTheOil')}>
          <div
            className={cx('mask')}
            onClick={() => setSearchVisible(false)}
          ></div>
          <div className={`as-modal ${cx('flyout')}`}>
            <FindTheRightOil
              country={country.isoCode}
              onVehicleSelect={onVehicleSelect}
              onProductSelect={onProductSelect}
              onWTBClick={onWTBClick}
              i18n={i18n}
              locales={replacements}
              baseAPI={process.env.REACT_APP_PROVIDER_URL}
              restore={isFastScan}
              mode={trade}
              setMode={setTrade}
            />
          </div>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state: IState) => ({
  vehicle: state.filter.vehicle,
  replacements: state.replacements,
  productCategoriesList: state.productCategoriesList,
  recommendedProducts: state.recommendedProducts,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setVehicle: (vehicle: IVehicle) => dispatch(actions.setVehicle(vehicle)),
  setRecommendedProducts: (v: IRecommendations[]) =>
    dispatch(actions.setRecommendedProducts(v)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Product);
